module.exports = __webpack_public_path__ + "static/media/leeds.43a8b431.png";